/**
 * Rules about accounts that the worker enforces and the portal has to state.
 *
 * These live here because both sides need the same number and disagreeing about
 * it is silently wrong rather than loudly broken: a form that accepts a
 * password the API will reject shows the user a raw `PASSWORD_TOO_SHORT` under
 * a hint that just told them the opposite.
 */

/**
 * The shortest password an account may have.
 *
 * Above Better Auth's default of 8 — long enough to matter, short enough that a
 * password manager's default output always clears it. `apps/api/src/auth.ts`
 * passes this to `minPasswordLength`, which is the check that actually binds;
 * the portal's forms use it to fail early and to word their hints.
 */
export const MIN_PASSWORD_LENGTH = 10;
